AuthRoute = require '../../mixins/authenticated-route'

App.CategoriesIndexRoute = Em.Route.extend AuthRoute,
  afterModel: ->
    categories = @modelFor('categories')

    if categories.get('length') > 0
      @transitionTo 'category', categories.get('firstObject.id')
